// extracted by mini-css-extract-plugin
module.exports = {"upper":"uppersign_upper__1JR61","txt":"uppersign_txt__3buXs"};